module.exports = __webpack_public_path__ + "static/img/RZ_pic09.9f41178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RZ_pic09.png
// module id = LFHK
// module chunks = 5